"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    chevronVariants: ()=>chevronVariants
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const baseTransition = 'transition-transform [transition-duration:var(--transition-duration-medium)] ease-in-out';
const chevronVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        group: baseTransition,
        chevronLeft: `${baseTransition} origin-[10px_12px]`,
        chevronRight: `${baseTransition} origin-[14px_12px]`
    },
    defaultVariants: {
        isOpen: false
    },
    variants: {
        isOpen: {
            true: {
                chevronLeft: '-rotate-90',
                chevronRight: 'rotate-90'
            }
        }
    }
});
exports.chevronVariants = __webpack_exports__.chevronVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "chevronVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
